import { format, parseISO } from "date-fns";

let CURRENCY = "INR";
let LOCALE = "en-IN";

export const setCurrency = (code) => {
  CURRENCY = (code || "INR").toUpperCase();
  LOCALE = CURRENCY === "INR" ? "en-IN" : "en-US";
};

export const curSym = () => {
  try {
    return (0)
      .toLocaleString(LOCALE, { style: "currency", currency: CURRENCY, minimumFractionDigits: 0, maximumFractionDigits: 0 })
      .replace(/[\d\s.,]/g, "");
  } catch {
    return "₹";
  }
};

const fmt = (n, opts) => {
  try {
    return new Intl.NumberFormat(LOCALE, { style: "currency", currency: CURRENCY, ...opts }).format(n || 0);
  } catch {
    return String(n || 0);
  }
};

export const inr = (n) => fmt(n, { minimumFractionDigits: 2 });
export const inr0 = (n) => fmt(n, { maximumFractionDigits: 0 });

export const fmtDate = (d) => {
  try {
    return format(parseISO(d), "d MMM yyyy");
  } catch {
    return d || "";
  }
};

export const todayStr = () => format(new Date(), "yyyy-MM-dd");
export const monthStr = (d = new Date()) => format(d, "yyyy-MM");

export const CURRENCIES = ["INR", "USD", "EUR", "GBP", "AED", "SGD", "AUD", "CAD", "JPY"];

export const TX_META = {
  income: { label: "Income", color: "text-income", bg: "bg-incomebg", sign: "+" },
  expense: { label: "Expense", color: "text-expense", bg: "bg-expensebg", sign: "-" },
  card_purchase: { label: "Card Purchase", color: "text-expense", bg: "bg-expensebg", sign: "-" },
  card_repayment: { label: "Card Repayment", color: "text-transfer", bg: "bg-transferbg", sign: "" },
  transfer: { label: "Transfer", color: "text-transfer", bg: "bg-transferbg", sign: "" },
  refund: { label: "Refund", color: "text-income", bg: "bg-incomebg", sign: "+" },
};

export const ACCOUNT_TYPE_LABELS = {
  bank: "Bank",
  cash: "Cash",
  upi_wallet: "UPI / Wallet",
  credit_card: "Credit Card",
};
